import { DateCalendarProps as MuiDateCalendarProps } from '@mui/x-date-pickers';
import { DateCalendar as MuiDateCalendar } from '@mui/x-date-pickers/DateCalendar';
import React from 'react';

import { OverrideDatePickerCommonProps } from '../datePickerAdapter';
import { useBaseAdapterProps, useDateBoundProps, useMonthAdapterProps } from '../picker.hooks';

type DateCalendarProps = OverrideDatePickerCommonProps<MuiDateCalendarProps>;

export const DateCalendar = (props: DateCalendarProps) => {
  const { timezone, value, onChange, onMonthChange, maxDate, minDate, ...restOfProps } = props;

  const baseAdapterProps = useBaseAdapterProps({ timezone, value, onChange });
  const monthAdapterProps = useMonthAdapterProps({ onMonthChange });
  const dateBoundProps = useDateBoundProps({ minDate, maxDate, timezone });

  return <MuiDateCalendar {...baseAdapterProps} {...monthAdapterProps} {...dateBoundProps} {...restOfProps} />;
};
